import React, { useState } from 'react';
import { Box, Checkbox, ListItemText, Menu, MenuItem } from '@mui/material';
import { Filter } from '@/types';
import { AddCircle } from '@mui/icons-material';
import { AddFiltersButton } from '../FilterAndSearchPanel/styles';

type Props = {
  filters: Filter[];
  filtersLimit: number;
  visibleFilters: Filter[];
  handleToggleFilter: (filter: Filter) => void;
};

const AddRemoveFilters = ({ filters, visibleFilters, filtersLimit, handleToggleFilter }: Props) => {
  const [anchorElement, setAnchorElement] = useState<HTMLElement | undefined>(undefined);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) =>
    setAnchorElement(event.currentTarget);
  const handleMenuClose = () => setAnchorElement(undefined);

  return (
    <Box>
      <AddFiltersButton onClick={handleMenuOpen}>
        <AddCircle />
      </AddFiltersButton>
      {anchorElement && (
        <Menu
          sx={{ mt: 0.5 }}
          anchorEl={anchorElement}
          open={Boolean(anchorElement)}
          onClose={handleMenuClose}
          MenuListProps={{ dense: true }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          disableScrollLock
          elevation={4}
        >
          {filters.slice(filtersLimit).map((filter) => (
            <MenuItem
              key={filter.key}
              onClick={() => handleToggleFilter(filter)}
              sx={{ py: 0, pl: 1, pr: 2, minWidth: 150 }}
            >
              <Checkbox
                sx={{ p: 0, pr: 0.5 }}
                checked={!!visibleFilters.some((f) => f.key === filter.key)}
              />
              <ListItemText primary={filter.label} />
            </MenuItem>
          ))}
        </Menu>
      )}
    </Box>
  );
};

export default AddRemoveFilters;
